import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import AppHeader from "../layouts/header";

const BULK_API_QUEUE_BASE = "https://studio-api.kgs.live/admin/queues";

function getBulkApiQueueUrl(streamKey?: string) {
  if (streamKey?.trim()) {
    return `${BULK_API_QUEUE_BASE}/queue/NEW_HLS/HLS_VIDEO-${streamKey.trim()}`;
  }
  return BULK_API_QUEUE_BASE;
}

export default function BulkApiQueue() {
  const search = useSearch({ from: "/bulk-api" });
  const navigate = useNavigate();
  const [streamKey, setStreamKey] = useState(search.stream_key || "");

  useEffect(() => {
    setStreamKey(search.stream_key || "");
  }, [search.stream_key]);

  const handleSearch = (value?: string) => {
    const key = (value ?? streamKey).trim();
    navigate({
      to: "/bulk-api",
      search: key ? { stream_key: key } : {},
    });
  };

  return (
    <div className="w-full h-full" style={{ height: "100%" }}>
      <AppHeader />
      <Row
        gutter={16}
        align="middle"
        style={{ padding: "12px 16px", background: "#f8fafc" }}
      >
        <Col>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate({ to: "/" })}
          >
            Dashboard
          </Button>
        </Col>
        <Col flex="auto">
          <Input.Search
            allowClear
            placeholder="Search by stream key"
            value={streamKey}
            enterButton={<SearchOutlined />}
            onChange={(event) => setStreamKey(event.target.value)}
            onSearch={handleSearch}
          />
        </Col>
      </Row>
      <iframe
        key={search.stream_key || "all"}
        style={{ width: "100%", height: "calc(100vh - 130px)", border: "none" }}
        src={getBulkApiQueueUrl(search.stream_key)}
        title="Bulk API Queue"
        allowFullScreen
      />
    </div>
  );
}
